/* eslint-disable */
import { transform } from "lodash-es";
import Swiper from "swiper";

/* eslint-enable */

class RelatedInsights {
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.sliderInsightsSections = this.sectionsContainer.getElementsByClassName("swiper-insights");
		this.$relatedInsights = this.sectionsContainer.querySelector('.related-insights');
	
		if (!this.$relatedInsights)
			return;
		
		this.$relatedInsightsCards = this.$relatedInsights.querySelectorAll('.card-insight');
		this.$relatedInsightsElements = this.$relatedInsights.querySelectorAll('.anima');

		if (this.sliderInsightsSections[0]) {
			this.init();
		}
		
		//console.log(this.sectionsContainer)
		//console.log(this.sliderInsightsSections)
		//console.log(this.$relatedInsights)
		
		//console.log(this.$relatedInsightsCards)
		//console.log(this.$relatedInsightsElements)
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		Array.from(this.sliderInsightsSections).forEach((section) => {
			return this.initSlider(section)
		});

		this.setAnimation();
	}

	setAnimation() {
		gsap.set(this.$relatedInsights, { opacity: 0.0001 });
        gsap.set(this.$relatedInsightsCards, { opacity: 0.0001, xPercent: 10});
        gsap.set(this.$relatedInsightsElements, { yPercent: 20, opacity: 0.0001 , onComplete: () => {
			this.initAnimate();
		} });
	}

	initAnimate() {
		this.animateModuleInsights = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$relatedInsights,
				start: 'top 70%'
			},
			onComplete: () => {
				gsap.set(this.$relatedInsightsElements, { clearProps: true });
				gsap.set(this.$relatedInsightsCards, { clearProps: true });
			}
        });
    
        this.animateModuleInsights.addLabel('step1');
		this.animateModuleInsights.to(this.$relatedInsights, { opacity: 1}, 'step1');
		this.animateModuleInsights.to(this.$relatedInsightsElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1');
        this.animateModuleInsights.to(this.$relatedInsightsCards, { opacity: 1, xPercent: 0,stagger: 0.1 }, 'step1+=0.3');
	}

	initSlider(section) {
		this.swiperInstance = new Swiper(section, {
			slidesPerView: 'auto',
			grabCursor: true, // Permite interacción con el ratón
			allowTouchMove: true, // Habilita deslizamiento táctil

			navigation: {
				nextEl: '.swiperButtonInsightsNext',
				prevEl: '.swiperButtonInsightsPrev',
			},
			 pagination: {
				el: '.swiper-pagination-insights',
				type: 'bullets',
				clickable: true,
			},
		});
		//console.log(this.swiperInstance.pagination);
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default RelatedInsights;
